const RELOAD_COUNT_KEY = "chunkReloadCount";
const MAX_RELOADS = 2;

let inMemoryReloadCount = 0;

export function isChunkLoadError(error) {
    if (!error) return false;
    const name = typeof error.name === "string" ? error.name : "";
    const message = typeof error.message === "string" ? error.message : String(error);
    return name === "ChunkLoadError" || /Loading (CSS )?chunk \S+ failed/i.test(message);
}

export function reloadOnChunkError(error) {
    if (!isChunkLoadError(error)) return false;

    try {
        const count = Number(window.sessionStorage.getItem(RELOAD_COUNT_KEY)) || 0;
        if (count >= MAX_RELOADS) return false;
        window.sessionStorage.setItem(RELOAD_COUNT_KEY, String(count + 1));
    } catch (e) {
        // sessionStorage blocked (private mode): fall back to an in-memory counter
        if (inMemoryReloadCount >= MAX_RELOADS) return false;
        inMemoryReloadCount += 1;
    }

    window.location.reload();
    return true;
}

let registered = false;

export function registerChunkErrorReload() {
    if (registered) return;
    registered = true;
    window.addEventListener("error", (event) => reloadOnChunkError(event && event.error));
    window.addEventListener("unhandledrejection", (event) => reloadOnChunkError(event && event.reason));
}
